import React from 'react';
import { TTimeOption } from '../../../api/endpoints/SubsetOption';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import CheckboxWrap from '../../Ui/CheckboxWrap';
import SelectAllControl from "../SelectAllControl";

const TimeSelector = (props: {
  values: Array<string>;
  spec: TTimeOption;
  onChange: (values: Array<string>) => void;
}) => {
  const { values, spec, onChange } = props;
  const options = spec.value.time;

  const onCheckboxChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <CheckboxWrap>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option}
              value={option}
              checked={values.includes(option)}
              name="time"
              onChange={(checked) => onCheckboxChange(option, checked)}
            />)
        }
      </CheckboxWrap>
    </div>
  );
};

export default TimeSelector;
